class SsoAuthorizationService {
  constructor(config, $http, AuthenticationService, $location, $state,customerIntegrationsService, localStorageService, jwtHelper) {
    this.config = config;
    this.$http = $http;
    this.authenticationService = AuthenticationService;
    this.$location = $location;
    this.$state = $state;
    this.isError = false;
    this.isSsoLaunch = false;
    this.errorMsg = null;
    this.jwtHelper = jwtHelper;
    this.customerIntegrationsService = customerIntegrationsService;
    this.localStorageService = localStorageService;
  }

  setSsoLaunch(value) {
    this.isSsoLaunch = !!value;
    this.localStorageService.set('ssoLaunch', value);
  }

  getSsoLaunch(){
    return this.localStorageService.get('ssoLaunch');
  }

  sso(ssoToken) {      
    const url = this.config.apiRoot + '/sso';
    const body = {
      id_token : ssoToken,
      state : 'sample_state'
    };
      
    return this.$http.post(url, body).then(this.onSsoResolve.bind(this), this.onSsoFailure.bind(this));
  }

  onSsoResolve(res) {
    const isTokenExpired = this.jwtHelper.isTokenExpired(res);
    if (res  && !isTokenExpired) {
      this.authenticationService.setToken(res);
      this.authenticationService.setSsoUserAccount(res);
      this.authenticationService.updateUserSessionSettings(res, true);
      this.onUserDetailsRetrievalSuccess();
    }else{
      this.onSsoFailure('Token expired');
    }
  }
 
  onSsoFailure(res) {
    this.setSsoLaunch();
    this.setError('UNKNOWN_ERROR', res);
  }

  onUserDetailsRetrievalSuccess() {
    this.setSsoLaunch(true);
    let user = this.localStorageService.get('user');
    this.customerIntegrationsService.setIntegrationTypes(user.customerId);

    let defaultState = 'dashboard';
    let redirectState = this.$location.search().redirect && this.$location.search().redirect.split('/');
    let stateName = redirectState && redirectState[1];
    let tabName = redirectState && redirectState[2];    
    let newState = stateName ? `home.${stateName}` : `home.${defaultState}`;
    
    this.redirect(newState,tabName);
  }

  redirect(newState,tabName) {
    this.$state.go(newState,{tabName});
  }

  setError(errorMsg, errorFromJSON) {
    this.isError = true;
    this.errorMsg = {
      message: errorMsg,
      details: errorFromJSON || ''
    };
  }

}

SsoAuthorizationService.$inject = ['config', '$http', 'AuthenticationService', '$location', '$state', 'customerIntegrationsService', 'localStorageService', 'jwtHelper'];

export
default SsoAuthorizationService;


// WEBPACK FOOTER //
// ./app/common/sso/ssoAuthorization.service.js